App.AdvertsIndexController = Em.Controller.extend
  needs: [ 'adverts' ]
  advertsBinding: 'model.adverts'
  restaurantsBinding: 'model.restaurants'

  actions:
    openAdvert: (advert) ->
      @transitionToRoute 'adverts.advert.edit', advert.get('id')
